import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

interface IScoring {
  min_point: number;
  max_point: number | null;
  scoring_weight: number;
}

export class AssetOptionsVM extends CommonOptionVM {
  required?: boolean;
  manual_rating?: boolean;
  hidden?: boolean;
  enable_score?: boolean;
  scoring?: IScoring;

  constructor(data: Partial<AssetOptionsVM> = {}) {
    super(data)
    this.required = data.required ?? undefined
    this.manual_rating = data.manual_rating ?? undefined
    this.hidden = data.hidden ?? undefined
    this.enable_score = data.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default AssetOptionsVM
export type { IScoring }